"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Integration = exports.ScriptName = void 0;
var ScriptName;
(function (ScriptName) {
    ScriptName["CONTENT_ACTIVE_TAB"] = "content-active-tab";
    ScriptName["CONTENT_GMAIL"] = "content-gmail";
    ScriptName["CONTENT_OUTLOOK"] = "content-outlook";
    ScriptName["CONTENT_OUTLOOK_MAIN"] = "content-outlook-MAIN";
    ScriptName["ROOT_SUMO"] = "css/rootSumo";
})(ScriptName = exports.ScriptName || (exports.ScriptName = {}));
var Integration;
(function (Integration) {
    Integration["SALESFORCE"] = "SALESFORCE";
    Integration["SALESFORCE_CEP"] = "SALESFORCE_CEP";
    Integration["MICROSOFT"] = "MICROSOFT";
    Integration["GOOGLE"] = "GOOGLE";
    Integration["HUBSPOT"] = "HUBSPOT";
    Integration["MS_DYNAMICS"] = "MS_DYNAMICS";
})(Integration = exports.Integration || (exports.Integration = {}));
